export default {
	title: "Osobné centrum",
	subTitle: ["Profil", "Bezpečnosť", "Systém"],
	menu: ["Upravit osobné informácie", "Používateľské meno", "Aktualizovať heslo", "Aktualizovať heslo transakcie"],
	updatePassword: {
		form: {
			label: ["Staré heslo", "Nové heslo", "Potvrďte nové heslo"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Staré heslo", "Nové heslo", "Potvrďte nové heslo"]
		}
	}
};
